import { xBaseTheme } from "@eisinc/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1280,
    stickyFooter: 1284,
    header: 1287,
    compactHeader: 1286,
    loadingOverlay: 1301,
    menu: 1290,
    drawer: 1290,
    modal: 9999,
    tabGroup: 400,
    toaster: 1400,
    default: 1,
    chatIcon: 9000,
    tooltip: 1306,
    floatingUi: 1500,
} as xBaseTheme["zIndex"];
